import {formatInstanteToDateTimeBR} from "~/utils/datetime";
import type {EventAddress, EventSimple} from "~/types/event";
import {cepFormatter} from "~/utils/util";

export function eventDateToString(startAt: string, endAt: string): string {
  return formatInstanteToDateTimeBR(startAt) + ' à ' + formatInstanteToDateTimeBR(endAt)
}

export function fullAddress (eventAddress: EventAddress | undefined): string {
  if (!eventAddress?.address) return 'Local do evento ainda não foi confirmado'
  const {address, addressNumber, city, state, cep} = eventAddress
  return `${address}, ${addressNumber}, ${city}, ${state} - ${cepFormatter(cep)}`
}

export function tagOpenCLose (event: EventSimple): string {
  const now = new Date();
  const end = new Date(event?.endAt || '')
  if (now > end) return "Encerrado"
  return "Andamento"
}
